import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const equipmentsApi = createApi({
    reducerPath: 'equipmentsApi',
    baseQuery: (fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin/equipments`, prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })),
    endpoints: (build) => ({
        getEquipments: build.query({
            query() {
                return {
                    url: '/getAll',
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['Furnishing Types']
        }),
        createFurnishingType: build.mutation({
            query: (data) => ({
                url: '/create',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Furnishing Types']
        }),
        deleteFurnishingType: build.mutation({
            query(id) {
                return {
                    url: `/delete/${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: ['Furnishing Types']
        }),
        updateFurnishingType: build.mutation({
            query({ id, data }) {
                return {
                    url: `/update/${id}`,
                    method: 'PUT',
                    body: data
                }
            },
            invalidatesTags: ['Furnishing Types']
        }),
    }),
});

export const {
    useLazyGetEquipmentsQuery,
    useGetEquipmentsQuery,
    useCreateFurnishingTypeMutation,
    useDeleteFurnishingTypeMutation,
    useUpdateFurnishingTypeMutation
} = equipmentsApi;